const faqs = [
  {
    id: 1,
    heading: 'How to schedule laundry services?',
    content: 'To schedule laundry services, you can use our online platform or contact our customer service. Explore the range of services, choose your preferences, and book a convenient time for laundry pickup and delivery.',
  },
  {
    id: 2,
    heading: 'How does the pricing and payment work?',
    content: 'Our pricing is transparent and based on the type and quantity of items. You can view the pricing details on our website. We accept various payment methods for your convenience, including online payments and cash on delivery.',
  },
  {
    id: 3,
    heading: 'Do you offer specialized cleaning services?',
    content: 'Yes, we provide specialized cleaning services for delicate fabrics, stain removal, and other specific requirements. Check our service menu or contact us for details on our specialized cleaning options.',
  },
  {
    id: 4,
    heading: 'How does the pickup and delivery process work?',
    content: 'Our pickup and delivery process is simple. Schedule a pickup, and our team will collect your laundry. Once cleaned, we\'ll deliver it back to your specified location. Track your order through our online platform for real-time updates.',
  },
  {
    id: 5,
    heading: 'Are your laundry practices environmentally friendly?',
    content: 'Yes, we prioritize environmental sustainability. Our laundry processes include eco-friendly detergents, energy-efficient machines, and responsible waste disposal. Learn more about our commitment to environmental practices on our website.',
  },
];

export default faqs;